export class ZonaSearchModel {
  nominativo:string;
  pageSize: number;
  pageNumber: number;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/user/zona-search.model.ts